import { RootState } from '../redux/root-state';

export const controllerStateSelector = (state: RootState) =>
  state.controllerState;
